
import { signUpWithReferrerUrl } from 'bits/location'
import { isRegistered } from 'bits/user_model'
import { Component, namespace, Prop, State, Vue } from 'bits/vue'
import OzAvatar from 'library/v4/components/OzAvatar.vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from 'library/v4/components/OzContainedButton.vue'
import type { User, Wall } from 'types'

@Component({
  components: { OzContainedButton, OzAvatar },
})
export default class AppBarAccountAvatar extends Vue {
  @Prop({ required: true }) user!: User
  @Prop({ default: 'auto' }) darkMode!: boolean | 'auto'
  @Prop({ default: false }) disabled!: boolean

  @State wall!: Wall
  @namespace('appBarAccount').Action showUserMenu!: () => void
  OzContainedButtonColorScheme = OzContainedButtonColorScheme
  OzContainedButtonSizePreset = OzContainedButtonSizePreset

  get isUserRegistered(): boolean {
    return isRegistered(this.user)
  }

  get avatarSize(): number {
    return 24
  }

  get signUpUrl(): string {
    return signUpWithReferrerUrl(this.wall.links.show)
  }

  get buttonLabel(): string {
    if (this.disabled) {
      return this.isUserRegistered
        ? this.__('Logged in as %{user}', { user: this.user.name || this.user.username })
        : this.__('Not logged in')
    }
    return this.isUserRegistered ? this.__('Show user menu') : this.__('Go to sign up page')
  }
}
